import http from "./httpService";
import { showProgressBar } from "../services/uiService";
import { hideProgressBar } from "../services/uiService";

const normalizeValue = (value) => {
  console.log(value);
  const numericPart = value.match(/\d+/);

  if (numericPart) {
    console.log(`CofO_${numericPart[0]}`);
    return `CofO_${numericPart[0]}`;
  }
  return value;
};

export async function search(searchEndPoint, params, ModuleName, paramsData, additionalSearch) {
  console.log(params);
  console.log(ModuleName);
  console.log(paramsData);
  var result = null;
  try {
    showProgressBar();

    console.log(params["CofO_No"]);
    const updatedParams = {
      ...params,
      CofO_No: normalizeValue(params.CofO_No),
    };

    // before redux params["CofO_No"] = normalizeValue(params["CofO_No"]);
    console.log(searchEndPoint + "/search");
    result = await http.post(searchEndPoint + "/search", {
      Params: updatedParams,
      ModuleName: ModuleName,
      ParamsData: paramsData,
      AdditionalSearch: additionalSearch,
    });

    hideProgressBar();
  } catch (ex) {
    console.log("searchService.search error: " + ex);
  }
  //hideProgressBar();
  return result;
}
